const baseURI = `${process.env.REACT_APP_HOST_URI}/api/${process.env.REACT_APP_BACKEND_RELEASE_VERSION}`;

export default baseURI;